module.exports = [{"id":1,"image":"school-1.jpg","name":"Camestone School","courses":"38 courses","available":"49 Available"},{"id":2,"image":"school-2.jpg","name":"Cotten End Forest School","courses":"38 courses","available":"49 Available"},{"id":3,"image":"school-3.jpg","name":"Elstow School","courses":"38 courses","available":"49 Available"},{"id":4,"image":"school-4.jpg","name":"Goldington Green Academy","courses":"38 courses","available":"49 Available"},{"id":5,"image":"school-1.jpg","name":"Camestone School","courses":"38 courses","available":"49 Available"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/topschools.json
// module id = JjnR
// module chunks = 1